export default "__VITE_ASSET__B$n0zkTk__"